import { render, staticRenderFns } from "./info-comp.vue?vue&type=template&id=ebd62fa2&scoped=true"
import script from "./info-comp.vue?vue&type=script&lang=js"
export * from "./info-comp.vue?vue&type=script&lang=js"
import style0 from "./info-comp.vue?vue&type=style&index=0&id=ebd62fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd62fa2",
  null
  
)

export default component.exports